import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES, SECTION } from '../routes.js';
import { scrollToHash } from '../lib/scrollToHash.js';
import './Navigation.css';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Klick auf einen Anker-Link:
  //  - bereits auf Home → smooth zu Section scrollen
  //  - auf anderer Page  → zu Home mit Hash navigieren (ScrollToTop übernimmt)
  const handleAnchor = (e, hash) => {
    if (pathname !== ROUTES.home) return; // Standard-Link-Navigation
    e.preventDefault();
    scrollToHash(hash);
    window.history.replaceState(null, '', `#${hash}`);
  };

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner container">
        <Link to={ROUTES.home} className="nav__brand" aria-label="Off Market – Startseite">
          <img
            src={`${process.env.PUBLIC_URL}/off_market.png`}
            alt="Off Market"
            className="nav__logo"
          />
        </Link>

        <div className="nav__cta">
          <Link
            to={`${ROUTES.home}#${SECTION.kontakt}`}
            onClick={(e) => handleAnchor(e, SECTION.kontakt)}
            className="nav__phone"
            aria-label="Zum Kontaktformular scrollen"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
            </svg>
            <span>Diskrete Beratung</span>
          </Link>
          <Link
            to={`${ROUTES.home}#${SECTION.kontakt}`}
            onClick={(e) => handleAnchor(e, SECTION.kontakt)}
            className="nav__btn"
          >
            Region anfragen
          </Link>
        </div>
      </div>
    </header>
  );
}
